import { Box, Grid, GridSize, Typography } from '@material-ui/core';
import type { ReactNode } from 'react';

export const GridItem = ({
  label,
  value,
  gridSizes = { xs: 12, sm: 4 },
}: {
  label: string;
  value: ReactNode;
  gridSizes?: {
    xs?: GridSize;
    sm?: GridSize;
    md?: GridSize;
  };
}) => (
  <Grid item xs={gridSizes.xs} sm={gridSizes.sm} md={gridSizes.md}>
    <Box mb={2}>
      <Typography variant="subtitle2" component="dt" gutterBottom>
        {label}
      </Typography>
      <Typography variant="body2" component="dd">
        {value}
      </Typography>
    </Box>
  </Grid>
);
